// extracted by mini-css-extract-plugin
export default {"paymentSection":"R4-z"};